export default __webpack_public_path__ + "static/media/tile_releases.a6fff1bc.jpg";